export default __webpack_public_path__ + "static/media/finish.51da9ebd.png";